<template>
  <div class="authenticate">
    <div class="authenticate-form">
      <h3>Behold!</h3>
      <a :href="googleLink" class="btn-outline">Google</a>
      <a :href="narnLink" class="btn-outline">narn.me</a>
      <a :href="yandexLink" class="btn-outline">Yandex</a>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class Authenticate extends Vue {
  get baseHost() {
    if (process.env.NODE_ENV == "development") {
      return "http://localhost:8080";
    }
    return window.location.origin;
  }

  get yandexLink() {
    return `https://oauth.yandex.ru/authorize?response_type=code&client_id=2c398cc13b194556bd5c1ede26eca319&redirect_uri=${this.baseHost}/api/v1/account/callback&state=${this.$route.fullPath}`;
  }

  get googleLink() {
    return `/api/v1/account/google_auth?baseHost=${this.baseHost}&redirect_to=${this.$route.fullPath}`;
  }

  get narnLink() {
    return `/api/v1/account/narn_auth?baseHost=${this.baseHost}&redirect_to=${this.$route.fullPath}`;
  }
}
</script>

<style lang="scss">
.authenticate {
  background: linear-gradient(180deg, #f0f0f0 0%, #d0d0d0 100%);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .authenticate-form {
    width: 250px;
    padding: 20px;
    border: 1px solid #ccc;
    text-align: center;
    h3 {
      margin-top: 0;
      font-weight: bold;
    }
  }
}
</style>
